<template>
  <v-runtime-template :template="includeTemplate"/>
</template>

<script>
import VRuntimeTemplate from 'v-runtime-template'
import wepHtmlToString from '@/plugins/_common/WepHtmlToString'
import { isEmpty } from 'lodash'

export default {
  name: 'Faq',
  components: {
    VRuntimeTemplate
  },
  data () {
    return {
      includeHtml: '',
      basePath: this.getStore('mmpAuth').state.basePath
    }
  },
  computed: {
    includeTemplate () {
      return this.includeHtml
    }
  },
  watch: {
  },
  beforeUpdate () {
  },
  updated () {
  },
  async created () {
    if (isEmpty(wepHtmlToString.mainTemplate)) {
      this.getEmptyTemplate('wepFaq.html')
    } else {
      this.includeHtml = wepHtmlToString.mainTemplate
    }
  },
  methods: {
    getEmptyTemplate (resourceUrl) {
      resourceUrl = this.getTemplatePath(resourceUrl)
      this.$http.loadRes(resourceUrl).then( (res) => {
        wepHtmlToString.mainTemplate = res
        this.includeHtml = wepHtmlToString.mainTemplate
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/contents/main/Faq.vue